/**
 * Search results batch size. Must be a multiple of the desktop search grid
 * (5 columns) so each loaded batch fills complete rows (BEC-24779).
 */
export const SEARCH_HITS_PER_PAGE = 20;

/**
 * Search overlay batches are intentionally smaller than full search-result batches.
 * The overlay mounts on demand, so limiting its first payload avoids blocking the
 * opening interaction with two to four rows of ProductCard work.
 */
export const SEARCH_OVERLAY_PRODUCTS_PER_PAGE = 10;
export const SEARCH_OVERLAY_INITIAL_PRODUCTS_COMPACT = 4;
export const SEARCH_OVERLAY_INITIAL_PRODUCTS_WIDE = 5;

/**
 * Cumulative hits for the Breitling-style "load more" pattern.
 * Page 1 → 20 hits, page 2 → 40 hits, always from offset 0.
 */
export function getCumulativeSearchHitsPerPage(
  page: number,
  hitsPerPage = SEARCH_HITS_PER_PAGE
): number {
  return hitsPerPage * Math.max(1, page);
}
